export default __webpack_public_path__ + "static/media/care_device_home.ec63b6fa.svg";